import { Component, Input, OnInit } from '@angular/core';
import { eColumnType } from '@hub/generated/enums';
import { CurrentUserService } from '@hub/services/CurrentUserService';

@Component({
  selector: 'g-columnDate',
  templateUrl: './columnDate.component.html',
})
export class ColumnDateComponent implements OnInit {
  constructor(private userService: CurrentUserService) { }

  private _format: string = 'dd-MMM-yyyy';
  convertedFormat:String;

  @Input() data: Date;
  @Input() isEditing: boolean = false;
  @Input() isDateWithTimezone: boolean = false;
  @Input() type: eColumnType = eColumnType.Date;
  @Input() set format(f: string) {
    this._format = f;
    switch(f) {
      case 'MM/DD/YYYY': 
        this.convertedFormat = 'MM/dd/y';
        break;
      default: 
        this.convertedFormat = f;
    }
  }
  get format() {
    return this._format;
  }

  @Input() timeZone: string = undefined;
  fDate: any;
  date: string;

  ngOnInit() {
  }
}
